import { useEffect, useState } from "react";
import { ArrowUp } from "lucide-react";

export default function ScrollToTop() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setVisible(window.scrollY > 400);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  if (!visible) return null;

  return (
    <button
      onClick={scrollToTop}
      className="
        hidden md:flex
        fixed bottom-6 right-6 z-50
        bg-[#22C55E] hover:bg-[#16A34A]
        text-white p-3 rounded-full shadow-lg
        transition-all duration-300
        hover:scale-110
      "
    >
      <ArrowUp size={20} />
    </button>
  );
}